import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';
import type { BasePlacement } from '@popperjs/core';

import { placementsMap } from '../../config';

import type { TArrow, TContentContainerStyles, TArrowStyles } from './models';

export const ArrowContentContainer: FC<React.PropsWithChildren<TArrow>> = ({
    arrowProps,
    children,
    className,
    dataTestId = 'popover',
    innerRef,
    onClose,
    onMouseLeave,
    onMouseOver,
    placement = placementsMap.BOTTOM,
    showCloseButton,
    style,
    IconCross,
    styles,
    maxWidth = 290,
}) => {
    const isHorizontal = [placementsMap.LEFT, placementsMap.RIGHT].includes(placement);
    const contentContainerPlacementStyles =
        styles[`${placement}ContentContainer` as TContentContainerStyles[BasePlacement]];
    const arrowPlacementStyles = styles[`${placement}Arrow` as TArrowStyles[BasePlacement]];

    return (
        <div
            ref={innerRef}
            className={cn(
                styles.contentContainer,
                contentContainerPlacementStyles,
                {
                    [styles.closeButtonPadding]: showCloseButton,
                },
                className
            )}
            data-test-id={`${dataTestId}-arrow-container`}
            onFocus={onMouseOver}
            onMouseLeave={onMouseLeave}
            onMouseOver={onMouseOver}
            role="tooltip"
            style={{ ...style, maxWidth }}
        >
            {children}
            <div
                ref={arrowProps.ref}
                className={cn(
                    styles.arrow,
                    arrowPlacementStyles,
                    {
                        [styles.arrowHorizontal]: isHorizontal,
                    },
                    arrowProps.className
                )}
                data-test-id={`${dataTestId}-arrow`}
                style={arrowProps.style}
            />
            {showCloseButton && (
                // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
                <div
                    className={styles.closeContainer}
                    data-test-id={`${dataTestId}-arrow-container-close-button`}
                    onClick={onClose}
                >
                    <IconCross height={16} width={16} />
                </div>
            )}
        </div>
    );
};
